import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

const VIEW_LABELS = {
    day: 'Día',
    week: 'Semana',
    month: 'Mes',
    agenda: 'Agenda',
};

/**
 * Toolbar propio de React Big Calendar: navegación, etiqueta del rango y
 * conmutador de vista con forma de control segmentado.
 */
export const CalendarToolbar = ({ label, onNavigate, onView, view, views, lockView = false }) => {
    const available = Array.isArray(views) ? views : Object.keys(views || {});
    const showViewSwitcher = !lockView && available.length > 1;

    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 py-3 border-b border-gray-200">
            <div className="flex items-center gap-2 min-w-0">
                <button
                    type="button"
                    onClick={() => onNavigate('PREV')}
                    className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                    aria-label="Periodo anterior"
                >
                    <ChevronLeftIcon className="w-5 h-5" aria-hidden="true" />
                </button>
                <h2 className="text-base font-bold text-gray-900 m-0 capitalize truncate">
                    {label}
                </h2>
                <button
                    type="button"
                    onClick={() => onNavigate('NEXT')}
                    className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                    aria-label="Periodo siguiente"
                >
                    <ChevronRightIcon className="w-5 h-5" aria-hidden="true" />
                </button>
            </div>

            <div className="flex items-center gap-2">
                <button
                    type="button"
                    onClick={() => onNavigate('TODAY')}
                    className="px-3 py-1.5 text-xs font-semibold text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                >
                    Hoy
                </button>

                {showViewSwitcher ? (
                    <div
                        className="flex items-center p-0.5 bg-gray-100 rounded-lg"
                        role="tablist"
                        aria-label="Vista del calendario"
                    >
                        {available.map((viewName) => (
                            <button
                                key={viewName}
                                type="button"
                                role="tab"
                                aria-selected={view === viewName}
                                onClick={() => onView(viewName)}
                                className={`px-3 py-1 text-xs font-semibold rounded-md transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 ${
                                    view === viewName
                                        ? 'bg-white text-indigo-700 shadow-sm'
                                        : 'text-gray-500 hover:text-gray-800'
                                }`}
                            >
                                {VIEW_LABELS[viewName] || viewName}
                            </button>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
